// src/frontend/js/modern/core/third-party-integration.js
import { eventBus, EVENTS } from './event-bus.js';
import { syncManager } from './sync.js';

const REINIT_EVENTS = [
	'jet-filter-content-rendered',
	'jet-woo-builder-content-rendered',
	'jet-engine/listing-grid/after-load-more',
	'jet-engine/listing-grid/after-lazy-load',
	'jet-cw-loaded',
];

// Events that originate from jQuery plugins and MUST be captured via jQuery.
// Native dispatch won't fire for these.
const JQUERY_ONLY_EVENTS = [
	'deContentLoaded',
	'wooco_gallery_loaded',
	'yith_wcwl_refresh_fragments',
	'wc_fragment_refresh',
	'wlfmc_reload_fragments',
];

class ThirdPartyIntegration {
	constructor() {
		this._initialized = false;
		this._jQueryBoundEvents = [];
	}

	init() {
		if (this._initialized) return;

		// REINIT events: only listen via jQuery (these are jQuery-triggered by third-party plugins)
		REINIT_EVENTS.forEach((evt) => this._onjQuery(evt, () => this._reinit()));

		// jQuery-only events
		JQUERY_ONLY_EVENTS.forEach((evt) => this._onjQuery(evt, () => syncManager.syncAll()));

		// Special case: wooco_gallery_loaded needs event detail
		this._offjQuery('wooco_gallery_loaded');
		this._onjQuery('wooco_gallery_loaded', (e) => {
			const productId = e.detail?.productId || e.detail;
			if (productId) {
				document.querySelectorAll(`*[id^="add_to_waitlist_popup_${productId}_"].popup_wrapper`).forEach(el => el.remove());
			}
			syncManager.syncAll();
		});

		// WordPress Customizer partial refresh (native DOM event)
		if (typeof wp !== 'undefined' && wp.customize && wp.customize.selectiveRefresh && wp.customize.widgetsPreview && wp.customize.widgetsPreview.WidgetPartial) {
			wp.customize.selectiveRefresh.bind('partial-content-rendered', () => {
				syncManager.syncAll();
			});
		}

		this._initialized = true;
	}

	/**
	 * Bind a jQuery event exactly once.
	 * Replaces the previous triple-binding pattern.
	 */
	_onjQuery(event, callback) {
		const $ = window.jQuery;
		if (!$) return;

		// Bind to document.body only — the standard WooCommerce/third-party target.
		// Binding to both document and document.body was causing double-execution.
		$(document.body).on(event, callback);
		this._jQueryBoundEvents.push({ event, callback });
	}

	/**
	 * Remove a previously bound jQuery event.
	 */
	_offjQuery(event) {
		const $ = window.jQuery;
		if (!$) return;

		this._jQueryBoundEvents = this._jQueryBoundEvents.filter(entry => {
			if (entry.event === event) {
				$(document.body).off(event, entry.callback);
				return false;
			}
			return true;
		});
	}

	_reinit() {
		eventBus.emit('ui:reinit');
		eventBus.emit(EVENTS.CONTENT_UPDATED);
		syncManager.syncAll();
	}

	destroy() {
		const $ = window.jQuery;
		if ($) {
			this._jQueryBoundEvents.forEach(({ event, callback }) => {
				$(document.body).off(event, callback);
			});
		}
		this._jQueryBoundEvents = [];
		this._initialized = false;
	}
}

export const thirdPartyIntegration = new ThirdPartyIntegration();
export default thirdPartyIntegration;
